import {TextField, Autocomplete} from "@mui/material";
import {useContext} from "react";
import AuthContext from "../../context/AuthContext";
import {validateUsemap} from "./AutocOneTrgFeat"


export default function AutocOneTrgVal(props: any) {
    let {user, logoutUser, authTokens} = useContext(AuthContext)

    const {trgObj, setTrgObj, setUsemapExists, projUID, setUsemapRedirectURL} = props

    let valsArr = trgObj.featLOVsList || []
    let isOpen:boolean = trgObj.featLOVsList?.length > 0
    let val = trgObj.trgValName || ''

    let fieldBgColor: string = isOpen ? 'white' : '#e9ecef'

    return (
        <Autocomplete
            key={1}
            value={val}
            onChange={(event, newValue) => {
                // console.log('OnChange: ', newValue)

                if (!newValue) {
                    setTrgObj((prevState: any) => {
                        return {...prevState, trgValUID: '', trgValName: ''}
                    })

                    setUsemapExists(false)
                } else {
                    // #1 -- set selected value
                    setTrgObj((prevState: any) => {
                        return {...prevState,
                            trgValUID: newValue.lovUID, trgValName: newValue.lovName
                        }
                    })

                   // #2 -- check if this trg-combination has already been mapped (exists)
                    let callObj = {projUID: projUID, trgFeatUID: trgObj.featUID, trgValUID: newValue.lovUID}
                    validateUsemap(authTokens, callObj).then((data) => {
                        setUsemapExists(data.exists)
                        if (data.exists) {
                            setUsemapRedirectURL(`../feat/map/${trgObj.catUID}/${trgObj.featUID}/${newValue.lovUID}/`)
                        }
                    })
                }
            }}

            isOptionEqualToValue={(option, value) => option.value === value.value}

            readOnly={!isOpen}
            disablePortal
            autoHighlight
            forcePopupIcon={false}
            size='small'
            id='combo-box-demo'
            options={valsArr}
            sx={{width: 'auto'}}
            ListboxProps={
                {style: {
                    fontSize: '0.8rem', fontFamily: "'Inter', sans-serif", color: 'black'}
                }}

            renderInput={(params) =>
                <TextField
                    {...params}
                    label=""
                    style={{backgroundColor: fieldBgColor}}
                    // InputProps={{
                    //     style: {height: 30}
                    // }}
                />}
        />
    );
}
